module.exports = __webpack_public_path__ + "img/select-img-4.5b515783.png";